module.exports = __webpack_public_path__ + "static/media/white_logo.7ac6e857.png";